import { createContextProvider } from '@/modules/common/composables/createContextProvider';

import type { BlacklistEditorContext } from '../../views/BlacklistAutoRuleEditor/composables/context/types';

export type { BlacklistEditorContext };

// The editor layout owns the page context (queries, form, submit, dirty guard) so the shell
// header and the routed page read one shared instance instead of each building their own.
const { provideContext, useContext } = createContextProvider<BlacklistEditorContext>('BlacklistEditor');

export const provideBlacklistEditorContext = provideContext;
export const useBlacklistEditorContext = useContext;
